import { Box, Button, TextField } from "@mui/material";
import { CoachListContext } from "../context/coachListContext";
import React from "react";

const RenderTopBar = (): React.JSX.Element => {
  const {
    search,
    setSearch,
    setAddCoach,
  }: {
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    setAddCoach: React.Dispatch<React.SetStateAction<boolean>>;
  } = React.useContext(CoachListContext);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 2,
        width: "100%",
        mb: 3,
      }}
    >
      <TextField
        size="small"
        color="secondary"
        sx={{
          width: "300px",
        }}
        type="text"
        id="search-Coach"
        label="Coach suchen"
        variant="outlined"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
      <Button
        size="large"
        variant="contained"
        color="secondary"
        sx={{
          height: "40px",
        }}
        onClick={() => setAddCoach(true)}
      >
        Coach anlegen
      </Button>
    </Box>
  );
};

export default RenderTopBar;
